import React, { useContext } from 'react';
import { useTranslation, Trans } from 'next-i18next';

import { getErrorMessage } from '@utils/validation';

import {
  SelectionControl,
  FormControl,
  SectionHeadingSmall,
} from '@common/components/forms';
import Hr from '@common/components/Hr';
import { ProvidersAdditional } from '../../MobileOrderForm.styled';
import { FormContext } from '../../FormWrapper';

import { Link } from './Link';

const SECTION_TRANSLATION_PREFIX =
  'mobile.orderForm.personalDetails.roamingSection';

const RoamingFormSection = () => {
  const { formik, handleChange, termsLinks } = useContext(FormContext);
  const { t } = useTranslation();

  const { values, handleBlur, isSubmitting, touched, errors } = formik;

  return (
    <React.Fragment>
      <SectionHeadingSmall spacingTop={['scale', 2]}>
        {t(`${SECTION_TRANSLATION_PREFIX}.title`, 'Roaming')}
      </SectionHeadingSmall>
      <ProvidersAdditional>
        {t(
          `${SECTION_TRANSLATION_PREFIX}.description`,
          'Wähle aus, wie sich, nicht in Deinem Abonnement enthaltene, Kosten für im Ausland aussehen sollen. Du kannst Deine Roaming-Einstellungen jederzeit unter «Mein Konto» auf Salt verändern. Mehr zu Roaming',
        )}
      </ProvidersAdditional>
      <div>
        <FormControl
          labelAs="label"
          hasError={touched.roaming && !!errors.roaming}
          message={touched.roaming && getErrorMessage(t, errors.roaming)}
        >
          <SelectionControl
            type="radio"
            id="agreeRoaming"
            name="roaming"
            value="agree"
            alignment="flex-start"
            onChange={handleChange}
            disabled={isSubmitting}
            checked={values.roaming === 'agree'}
            onBlur={handleBlur}
            label={t(
              `${SECTION_TRANSLATION_PREFIX}.roamingLabel`,
              'Roaming aktivieren. Ausgabelimite CHF 500.– pro Monat für Internet, Anrufe und SMS.',
            )}
          />
        </FormControl>
      </div>
      <div>
        <FormControl
          labelAs="label"
          hasError={touched.roaming && !!errors.roaming}
          message={touched.roaming && getErrorMessage(t, errors.roaming)}
        >
          <SelectionControl
            type="radio"
            id="disagreeRoaming"
            name="roaming"
            value="disagree"
            alignment="flex-start"
            onChange={handleChange}
            disabled={isSubmitting}
            checked={values.roaming === 'disagree'}
            onBlur={handleBlur}
            label={t(
              `${SECTION_TRANSLATION_PREFIX}.noRoamingLabel`,
              'Roaming nicht aktivieren. Keine Benutzung im Ausland.',
            )}
          />
        </FormControl>
      </div>

      <Hr />

      <ProvidersAdditional>
        <Trans
          i18nKey={`${SECTION_TRANSLATION_PREFIX}.providersAdditionalDescription`}
          t={t}
          components={[
            <Link
              href={termsLinks.dataProtectionDeclaration}
              legacyBehavior
              key="providersAdditionalDescription"
            />,
          ]}
        />
      </ProvidersAdditional>
      <FormControl labelAs="div">
        <SelectionControl
          type="checkbox"
          id="terms_and_conditions_salt"
          name="terms_and_conditions_salt"
          value={values.terms_and_conditions_salt}
          onChange={handleChange}
          disabled={isSubmitting}
          checked={values.terms_and_conditions_salt}
          onBlur={handleBlur}
          label={
            <span>
              <Trans
                i18nKey={`${SECTION_TRANSLATION_PREFIX}.termsAndConditionsSaltLabel`}
                t={t}
                components={[
                  <Link
                    href={termsLinks.termsAndConditions}
                    key="termsAndConditionsSaltLabel"
                    legacyBehavior
                  />,
                ]}
              />
            </span>
          }
        />
      </FormControl>
      {values.is_existing_number === 'yes' && (
        <FormControl labelAs="div">
          <SelectionControl
            type="checkbox"
            id="port_phone_number"
            name="port_phone_number"
            alignment="flex-start"
            value={values.port_phone_number}
            onChange={handleChange}
            disabled={isSubmitting}
            checked={values.port_phone_number}
            onBlur={handleBlur}
            label={t(
              `${SECTION_TRANSLATION_PREFIX}.portPhoneNumberLabel`,
              'Ich ermächtige Salt, meine aktuelle Telefonnummer zu portieren.',
            )}
            variant="body2"
          />
        </FormControl>
      )}
    </React.Fragment>
  );
};

export default RoamingFormSection;
